import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  users: [],
  guards: [],
}

export const getUsers = createAsyncThunk('user/getUsers', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId } = state.auth

  let userURL;
  if (authId === 100) {
    userURL = 'api/gateusersNew/';
  } else if (authId === 1) {
    userURL = 'api/gateusersNew/subscriber/' + subscriberId;
  } else {
    userURL = 'api/gateusersNew/customer/' + customerId;
  }
  if (!userURL) return {users: [], guards: []}

  return await fetch(apiURL + userURL, {
    method: 'get',
    headers: { 'Accept': 'application/json', 'Authorization': webToken },
    credentials: 'include'
  })
  .then(response => response.json())
  .then(data => {
    return {users: data.rows, guards: data.rows.filter( u => u.GateAcl.id === 3 )}
  })
  .catch(error => {
      console.error('Error:', error);
      return {users: [], guards: []}
  })
});

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.fulfilled, (state, action) => {
        state.users = action.payload.users
        state.guards = action.payload.guards
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setUserState } = userSlice.actions
export default userSlice.reducer
